import { Button, Divider, Modal, Row } from "antd";
import CommentCard from "components/UI/CommentCard/CommentCard";
import { isUserClient } from "library/helpers/fonction";
import { loadState } from "library/helpers/localStorage";
import PropTypes from "prop-types";
import { Fragment, useEffect, useState } from "react";
import { IoMdHeart } from "react-icons/io";
import { Element } from "react-scroll";
import ReviewWrapper, {
  HeaderSection,
  ModalTitle,
  RatingSearch,
  RatingStatus,
} from "./Review.style";
import ReviewForm from "./ReviewForm";
import { reviewTempData } from "./ReviewTempData";

const CommentBox = ({
  reviews,
  nbReviewsToDisplay,
  reviewDisplayTextLength,
}) => {
  return reviews && reviews.length !== 0
    ? reviews.slice(0, nbReviewsToDisplay).map((singleReview, i) => {
        return (
          <Fragment key={i}>
            {i === 0 && <Divider />}
            <CommentCard key={i}
              singleReview={singleReview}
              reviewDisplayTextLength={reviewDisplayTextLength}
            />
          </Fragment>
        );
      })
    : "Aucun avis trouvé";
};

const DisplayMoyenneRating = ({ defaultRating, moyenneRating }) => {
  const res = [];

  for (let i = 0; i < defaultRating; i++) {
    res.push(
      <IoMdHeart key={i}
        className={
          i < moyenneRating
            ? "color-theme-primary"
            : "color-theme-primary-fuzzy"
        }
      />
    );
  }
  return res;
};

const Review = (props) => {
  const { displayAddBtn, displayDetail, idHotel } = props;

  const [isClient, setIsClient] = useState(isUserClient(loadState("user")));

  const [loading, setLoading] = useState(true);

  //TODO delete code commented
  const [reviewData, setReviewData] = useState({
    listeReviews: [], //reviewTempData.reviews,
    moyenneRating: 0, //reviewTempData.moyenneRating,
    nbAvis: 0, //reviewTempData.nbAvis,

    defaultRating: reviewTempData.defaultRating,
    nbReviewsToDisplay: reviewTempData.nbReviewsToDisplay,
    nbReviewsToDisplayPerClick: reviewTempData.nbReviewsToDisplayPerClick,
    reviewDisplayTextLength: reviewTempData.reviewDisplayTextLength,
    language: false,
    isRevieModalOpen: false,
    resetForm: 0
  });

  
  useEffect (() =>{
    const fetchDataSource = () => {
      setLoading(true);
      fetch(process.env.REACT_APP_API_URL+"/commentaires/hotel/"+idHotel,
      {
        method : 'GET',
        headers : {
          'Content-type': 'application/json',
        }
      }).then(
        (res) =>
          res.json().then((listeReviews => {
            setLoading(false);
            const listeReviewComment = listeReviews.filter(review => review.titre || review.message);
            setReviewData({
              ...reviewData,
              moyenneRating: listeReviews.filter(review => review.note).length > 0 
                ? 
                  Math.round(
                    +listeReviews.reduce((acc, currentValue) => acc + currentValue?.note , 0) / listeReviews.length
                  )
                : 0,
              nbAvis: listeReviewComment.length,
              listeReviews: listeReviewComment
            })
          }))
      ).catch((error) => {
        setLoading(false);
      });
    }
    if(loading) {
      fetchDataSource();
    }
  
  },[idHotel])

  
  
  const handleModalOpen = (isRevieModalOpen) => {
    setReviewData({ ...reviewData, isRevieModalOpen, resetForm: ++reviewData.resetForm });
  };

  const showMoreReviews = () => {
    setReviewData({
      ...reviewData,
      nbReviewsToDisplay:
      reviewData.nbReviewsToDisplay + reviewData.nbReviewsToDisplayPerClick,
    });
  };

  return (
    <Element name="reviews" className="reviews">
      <ReviewWrapper>
        <HeaderSection>
          <RatingStatus>
            <DisplayMoyenneRating
              defaultRating={reviewData.defaultRating}
              moyenneRating={reviewData.moyenneRating}
            ></DisplayMoyenneRating>
            <span className="no-wrap">({reviewData.nbAvis} avis)</span>
          </RatingStatus>
          <div>
            {displayAddBtn && isClient && (
              <RatingSearch>
                <Button
                  type="primary"
                  onClick={() => handleModalOpen(true)}
                >
                  Votre avis
                </Button>
                <Modal
                  open={reviewData.isRevieModalOpen}
                  onCancel={() => handleModalOpen(false)}
                  footer={null}
                  width="100%"
                  maskStyle={{ backgroundColor: "rgba(255, 255, 255, 0.9)" }}
                  wrapClassName="review_modal"
                >
                  <ModalTitle>Donnez votre avis ici</ModalTitle>
                  <ReviewForm 
                    closeModal={()=> handleModalOpen(false)}
                    idHotel={idHotel}
                    resetForm={reviewData.resetForm}
                    />
                </Modal>
              </RatingSearch>
            )}
          </div>
        </HeaderSection>
        {displayDetail && reviewData.listeReviews.length > 0 && (
          <div>
            <Row>
              <CommentBox
                reviews={reviewData.listeReviews}
                nbReviewsToDisplay={reviewData.nbReviewsToDisplay}
                reviewDisplayTextLength={reviewData.reviewDisplayTextLength}
              />
            </Row>
            <Row>
              {reviewData.nbReviewsToDisplay < reviewData.listeReviews.length && (
                <Button
                  className="btn-more-review"
                  type="primary"
                  onClick={() => showMoreReviews("review")}
                >
                  Voir plus
                </Button>
              )}
            </Row>
          </div>
        )}
      </ReviewWrapper>
    </Element>
  );
};

Review.propTypes = {
  statusHeadingStyle: PropTypes.object,
  filterHeadingStyle: PropTypes.object,
  ratingLabelStyle: PropTypes.object,
  ratingCountStyle: PropTypes.object,
};

Review.defaultProps = {
  statusHeadingStyle: {
    color: "#2C2C2C",
    fontSize: ["17px", "20px", "25px"],
    mr: "10px",
  },
  filterHeadingStyle: {
    color: "#2C2C2C",
    fontSize: "15px",
    fontWeight: "700",
    lineHeight: "1.2",
    mb: "0.5em",
  },
  ratingLabelStyle: {
    fontSize: "13px",
    fontWeight: "400",
    color: "#2c2c2c",
    flex: "1",
  },
  ratingCountStyle: {
    fontSize: "13px",
    fontWeight: "400",
    color: "#2c2c2c",
    ml: "8px",
  },
};

export default Review;
